export default {
  process: {
    step1: 'Background and Roads',
    step2: 'Layout Elements',
    step3: 'Set Exit',
    next: 'Next',
    previous: 'Previous',
    finish: 'Finish',
    nextWarning: 'Place the elements inside the layout area first.',
  },
  tool: {
    select: 'Selected',
    erase: 'Erase',
    selectTip:
      'Click or drag in the layout area to select the required grid and place the area.',
  },
  step1Editor: {
    edit1: {
      title: 'Set Grid',
      rowColumnNum: 'Rows and Columns',
      row: 'Rows',
      column: 'Columns',
      gridSize: 'Grid Size',
    },
    edit2: {
      title: 'Set Background',
      size: 'Dimension',
      sizeScreenSplit: '[Size] Separate Setting',
    },
    edit3: {
      title: 'Set Roads',
      chooseRoad: 'Choose Roads',
      chooseArea: 'Choose Area',
      rules: 'Element Placement Rules',
      onRoad: 'Elements can only be placed on roads',
      notOnRoad: 'Elements cannot be placed on roads',
      area: 'Area',
    },
  },
  step2Editor: {
    edit1: {
      title: 'Movement Direction',
      titleTip:
        'If enabled, the movement direction of the element can be selected from the following 5 directions; if disabled, the element can only move straight in one direction.',
      uploadForward: 'Please upload a straight arrow',
      uploadTurnLeft: 'Please upload a u-turn left arrow',
      uploadTurnRight: 'Please upload a u-turn right arrow',
      uploadLeft: 'Please upload a turn left arrow',
      uploadRight: 'Please upload a turn right arrow',
      Forward: 'Straight Arrow',
      TurnLeft: 'U-turn Left Arrow',
      TurnRight: 'U-turn Right Arrow',
      Left: 'Turn Left Arrow',
      Right: 'Turn Right Arrow',
      setting: {
        title: 'Appearance',
        applyToAll: 'Apply to All Arrows',
      },
    },
    edit2: {
      title: 'Set Main Elements',
      elementTip:
        'Determine whether to enable the element during operation. If disabled, the element is disabled.',
      gridNum: 'Number of Grid Occupations',
      pivot: 'Arrow Anchor',
      pivotDesc:
        'The green dot is the arrow.<br/>You can move it to adjust the position where the arrow appears.',
    },
    edit3: {
      title: 'Set Obstacle Type',
    },
    addCustomEleType: 'Add Custom Element Type',
    customEle: {
      eleName: 'Custom Element Category',
      dialog: {
        title: 'Manage Custom Element Types',
      },
    },
    addGroupDialog: {
      mainTitle: 'Add Main Element Category',
      obsTitle: 'Add Obstacle Type',
      customTitle: 'Add Custom Element Category',
      categoryName: 'Category Name',
      gridNum: 'Grids Occupied',
      categoryNamePlaceholder: 'Please enter a category name',
      gridNumPlaceholder: 'Please enter the number of occupied grids',
      emptyWarning: 'Cannot be empty',
      integer: 'It must be an integer.',
    },
    nextWarning:
      'The current element placement is abnormal. Please check and confirm before proceeding to the next step.',
    deleteMainWarningTitle: 'Delete Main Elements Group',
    deleteMainWarningText:
      'This element group has been added to the layout. Deleting it may cause the playable ad to not function properly. Confirm deletion?',
    elementSetting: {
      title: 'Appearance',
      moveDirSelect: 'Select Movement Direction',
      forward: 'Straight',
      turnLeft: 'U-turn Left',
      turnRight: 'U-turn Right',
      left: 'Turn Left',
      right: 'Turn Right',
      backSetting: 'Reverse Settings',
      backSettingTip:
        'Determine whether the element supports backward movement during trial play.',
      turn: 'U-turn',
      noTurn: 'Backward',
      applyToAll: 'Apply to All',
      reset: 'Reset',
    },
  },
  step3Editor: {
    title: 'Exit Settings',
    titleTip: 'Match the main element with a different type of exit.',
    dialog: {
      title: 'Add Exit Category',
      categoryName: 'Category Name',
      categoryNamePlaceholder: 'Enter',
      exitDir: 'Exit Direction',
      exitDirTip:
        'Determine the direction in which the corresponding element exits.',
      anyDir: 'Any Direction',
      fixedDir: 'Fixed Direction',
      emptyWarning: 'Cannot be empty',
    },
    categoryTip:
      'Determine whether to enable the element during operation. If disabled, the element is disabled.',
    selectImage: 'Select Image',
    selectArea: 'Select Area',
    area: 'Area',
    bindEle: 'Corresponding Element',
    bindElePlaceholder: 'Please Select',
    nextWarning: 'Please select the corresponding element for {exit} first.',
  },
  sceneEditorTip: 'Click here to enter quick layout mode.',
  newGuide: {
    tip1: 'Click to select the element that needs to be placed inside the grid.',
    tip2: 'Click or slide in the layout area to place the element.',
    tip3: 'You can click on the element to rotate or move it, or use the arrow keys on the keyboard to move it.',
    jump: 'Skip',
    next: 'Next',
    know: 'Got it',
  },
  resourcePoolTip:
    'Please add an image with the head of the element facing up.',
}
